import { render, staticRenderFns } from "./HeaderAvatar.vue?vue&type=template&id=e06bb920&scoped=true&"
import script from "./HeaderAvatar.vue?vue&type=script&lang=js&"
export * from "./HeaderAvatar.vue?vue&type=script&lang=js&"
import style0 from "./HeaderAvatar.vue?vue&type=style&index=0&lang=less&"
import style1 from "./HeaderAvatar.vue?vue&type=style&index=1&id=e06bb920&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06bb920",
  null
  
)

export default component.exports